import { css, Flex, styled, Theme } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

const hideOnLoading = () => css`
  visibility: hidden;
  opacity: 0;
`;

const showOnLoading = () => css`
  visibility: initial;
  transition: ${animationTransition('opacity')};
`;

export const StyledFlexAloha = styled(Flex)<{ loading: boolean; isPreviewing: boolean; heightOffset?: number }>`
  width: 100%;
  flex-direction: column;
  ${({ loading }) => (loading ? hideOnLoading : showOnLoading)}

  height: ${({ heightOffset }) => (heightOffset ? `calc(100vh - ${heightOffset}px)` : '100vh')};
  max-height: 100%;
  z-index: 1;
  overflow: auto;

  ${({ isPreviewing }) =>
    isPreviewing &&
    `
    * {
        pointer-events: none;
      }
  `}
`;

const disableTopMarginOnMobile = (theme: Theme) => `
  @media (max-width: ${theme.breakpoints.sm4}) {
    & > :first-child {
      margin-top: 0;
    }
  }
`;

export const PageContainer = styled.div<{ backgroundColor?: string; textColor?: string; disableBottomMargin?: boolean; disableMobileTopMargin?: boolean }>`
  display: inline-block;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};

  ${({ disableBottomMargin, theme }) => {
    if (disableBottomMargin) {
      return;
    }

    return `
      @media (min-width: ${theme.breakpoints.sm2}) {
        & > :first-child {
          margin-bottom: 4rem;
        }
      }
  `;
  }}

  ${({ disableMobileTopMargin, theme }) => {
    if (!disableMobileTopMargin) {
      return;
    }
    return disableTopMarginOnMobile(theme);
  }}
`;

export const CustomPageContainer = styled.div<{ backgroundColor?: string; textColor?: string; disableMobileTopMargin?: boolean }>`
  display: flex;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};

  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    margin-bottom: 4rem;
  }

  ${({ disableMobileTopMargin, theme }) => {
    if (!disableMobileTopMargin) {
      return;
    }
    return disableTopMarginOnMobile(theme);
  }}
`;
